import { useState } from "react";
import "../sign.css";
import ASSETS from "../../../app/config/assets";
import Logo from "../../../ui/atoms/logo/Logo";
import ThemeSwitcher from "../../../ui/molecules/theme-switcher/ThemeSwitcher";
import LanguageSelector from "../../../ui/molecules/languages/LanguageSelector";
import MessageBox from "../../../ui/atoms/message-box/MessageBox";
import InputText from "../../../ui/atoms/inputs/input-text/InputText";
import Button from "../../../ui/atoms/buttons/Button";
import Loading from "../../../ui/atoms/loading/Loading";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
//
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { wait } from "../../../core/utils/helpers";
import { RegisterSchema } from "../../../core/utils/validators/authentication";
//
import { onInscription } from "../services/authentication";

const SignUp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isSending, setIsSending] = useState(false);
  const [isShowingMsgBox, setIsShowingMsgBox] = useState(false);
  const [messageData, setMessageData] = useState({ type: "", text: "" });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(RegisterSchema),
  });

  const onSubmit = async (data) => {
    setIsSending(true);
    await wait(3000);
    //
    onInscription(data)
      .then((response) => {
        setIsSending(false);
        
        const _data = response?.data;

        if (_data?.status) {
          setIsShowingMsgBox(true);
          setMessageData({ type: "success", text: _data?.message });
          reset();

          const timer = setTimeout(() => {
            setIsShowingMsgBox(false);
            setMessageData({ type: "", text: "" });
            navigate("/signin", { replace: true });
          }, 2000);
          return () => clearTimeout(timer);
        } else {
          setIsShowingMsgBox(true);
          setMessageData({ type: "warning", text: _data?.message });
          //
          const timer = setTimeout(() => {
            setIsShowingMsgBox(false);
            setMessageData({ type: "", text: "" });
          }, 4000);
          return () => clearTimeout(timer);
        }
      })
      .catch((error) => {
        setIsSending(false);
        setIsShowingMsgBox(true);
        if (!error?.response) {
          setMessageData({ type: "info", text: "No server response" });
        } else {
          setMessageData({
            type: "warning",
            text: error?.response?.data?.detail?.message,
          });
        }
        const timer = setTimeout(() => {
          setIsShowingMsgBox(false);
          setMessageData({ type: "", text: "" });
        }, 2000);
        return () => clearTimeout(timer);
      });
  };

  return (
    <div className="w-screen h-screen position-relative bg-primary d-flex">
      <div className="w-40 h-full sign-section position-relative bg-white p-sm">
        <div className="sign-head w-full d-flex justify-space-between align-center">
          <Logo to={"/"} width={"100px"} />
          <div className="sign-switchers d-flex justify-space-between align-center">
            <ThemeSwitcher />
            <LanguageSelector />
          </div>
        </div>
        <form
          className="sign-body w-full d-flex justify-center align-center flex-col pl-lg pr-lg"
          onSubmit={handleSubmit(onSubmit)}
        >
          <h1 className="mb-lg">{t("sign.sign_up")}</h1>
          {isShowingMsgBox && (
            <div className="w-full mb-xs">
              <MessageBox type={messageData?.type} msg={messageData?.text} />
            </div>
          )}
          <div className="w-full d-flex justify-space-between align-center mt-md gap-xs">
            <div className="w-50">
              <InputText
                type={"text"}
                register={register}
                name="firstname"
                title={t("user.firstname")}
                error={errors?.firstname?.message}
              />
            </div>
            <div className="w-50">
              <InputText
                type={"text"}
                register={register}
                name="lastname"
                title={t("user.lastname")}
                error={errors?.lastname?.message}
              />
            </div>
          </div>
          <div className="w-full mt-md">
            <InputText
              type={"text"}
              register={register}
              name="mail"
              title={t("user.email")}
              error={errors?.mail?.message}
            />
          </div>
          <div className="w-full mt-md">
            <InputText
              type={"password"}
              register={register}
              name="password"
              title={t("user.password")}
              error={errors?.password?.message}
            />
          </div>
          <div className="w-full mt-md">
            <InputText
              type={"password"}
              register={register}
              name="confirmPassword"
              title={t("user.confirm_password")}
              error={errors?.confirmPassword?.message}
            />
          </div>
          <div className="w-full mt-lg">
            {isSending ? (
              <Loading type={"type-1"} />
            ) : (
              <Button
                type={"submit"}
                preferedStyle={"normal"}
                title={t("sign.sign_up")}
                action={null}
              />
            )}
          </div>
        </form>
        <div className="sign-foot w-full d-flex justify-center align-center">
          <span className="sign-foot-text">{t("sign.have_account")}</span>
          <Link to={"/signin"} className="sign-links ml-xs">
            <span>{t("sign.sign_in")}</span>
          </Link>
        </div>
      </div>
      <div className="w-60 h-full sign-section to-hide position-relative bg-primary d-flex justify-center align-center">
        <img src={ASSETS?.signup} alt="Sign Up" className="w-full radius-md" />
      </div>
    </div>
  );
};

export default SignUp;
